import React from 'react';
type LogoProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
const sizes = {
  sm: {
    name: 'text-[9px]',
    main: 'text-xl md:text-2xl'
  },
  md: {
    name: 'text-[10px]',
    main: 'text-3xl md:text-4xl'
  },
  lg: {
    name: 'text-xs md:text-sm',
    main: 'text-4xl sm:text-5xl md:text-6xl'
  }
};
export function Logo({
  size = 'md',
  className = ''
}: LogoProps) {
  const s = sizes[size];
  return <div className={`flex flex-col items-center ${className}`} data-id="element-93" data-mp="mscn2pxmimwx">
      <span className={`${s.name} font-semibold uppercase tracking-[0.55em] text-white/70 pl-[0.55em]`} data-id="element-94" data-mp="mqruh5uvde1p">
        Gabriel Beltran
      </span>
      <div className="mt-1.5 flex items-stretch" data-id="element-95" data-mp="dr4qqdeo3w5h">
        <span className={`font-display ${s.main} bg-brand-red px-2 py-0.5 leading-none text-white`} data-id="element-96" data-mp="duiu9oz2ibei">
          48 HRS AI
        </span>
        <span className={`font-display ${s.main} px-2 py-0.5 leading-none text-white`} data-id="element-97" data-mp="2yhlzlwtbl7mc">
          CASH MACHINE
        </span>
      </div>
    </div>;
}